import { ActionTypes } from "../constants/action-types";

/*
Add-to-cart Action Types with payload
*/
export const initializeCauseData = (causeData) => {
    return {
        type: ActionTypes.INITIALIZE_CAUSE_DATA,
        payload: causeData,
    };
};

export const setDefaultCause = (cause) => {
    return {
      type: ActionTypes.DEFAULT_CAUSE,
      payload: cause,
    };
  };

  export const setUserCause = (cause) => {
    return {
      type: ActionTypes.USER_CAUSE,
      payload: cause,
    };
  };

  export const setSidebarWidth = (cause) => {
    return {
      type: ActionTypes.SIDEBAR_CAUSE,
      payload: cause,
    };
  };

  export const setMenuData = (value) => {
    return {
      type: ActionTypes.MENU_DATA,
      payload: value,
    };
  }

  export const setGlobalActiveTab = (value) => {
    return {
      type: ActionTypes.GLOBAL_ACTIVE_TAB,
      payload: value,
    };
  }

  export const setPLPWishlistClicked = (value) => {
    return {
      type: ActionTypes.PLP_WISHLIST_CLICKED,
      payload: value,
    };
  }


  export const showCharityActiveMessage=(value)=>{
    return {
      type:ActionTypes.SHOW_CHARITY_ACTIVE_MESSAGE,
      payload:value,
    }
  }